// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groupedMenuCss_g10yq4am{max-width:600px;min-width:80px;}
.listWrapperCss_lgthr31{padding:0 10px;}
.matchingTextCss_modfebh{color:var(--gray100);font-weight:bold;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/autosuggest/AutosuggestList.css"],"names":[],"mappings":"AAAA,yBAAyB,eAAe,CAAC,cAAc,CAAC;AACxD,wBAAwB,cAAc,CAAC;AACvC,yBAAyB,oBAAoB,CAAC,gBAAgB,CAAC","sourcesContent":[".groupedMenuCss_g10yq4am{max-width:600px;min-width:80px;}\n.listWrapperCss_lgthr31{padding:0 10px;}\n.matchingTextCss_modfebh{color:var(--gray100);font-weight:bold;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
